import { MotorStatusMdl } from './MotorStatusMdl';
export class ProposalTrackingReq
{

     public CustomId:string;
     public  IqamaNo: string;
     public JSONStr: string;
     public  ProposalID: number;
     public  ProposalNo: string;
     public  RegNo: string;
     public  ScreenNo: string;
     public  SequenceNo: string;    
     public  st: MotorStatusMdl=new MotorStatusMdl();
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/ProposalTrackingReq.ts